var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99509 2C5.5795 2 2.0001 5.57983 2 9.99516C2 14.4105 5.5795 17.9903 9.99509 17.9903C11.8307 17.9903 13.5533 17.3417 14.9029 16.3013L19.2706 20.7077C19.6609 21.0974 20.3169 21.0974 20.7073 20.7077C21.0976 20.3169 21.0976 19.6613 20.7073 19.2706L16.304 14.8972C17.3442 13.548 17.9902 11.8311 17.9902 9.99516C17.9902 5.57983 14.4107 2 9.99509 2ZM9.99509 3.99879C13.3068 3.99879 15.9913 6.68317 15.9914 9.99516C15.9914 13.3072 13.3068 15.9915 9.99509 15.9915C6.68342 15.9915 3.99887 13.3072 3.99877 9.99516C3.99877 6.68317 6.68342 3.99879 9.99509 3.99879Z",
    fill: "#159CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.341bd2b85c15609888487802950cbea4.svg";
export { ForwardRef as ReactComponent };